/*
  El Laguito Cigars — S.T. DUPONT PEN CART ADD-ON QUICK-ADD (15% off)
  -------------------------------------------------------------------
  Sibling of assets/elg-dupont-addon.js (the lighter card). Shows a
  "Complete your pen — save 15%" card in the cart drawer (and on /cart) whenever an
  S.T. Dupont WRITING INSTRUMENT is in the cart. Two kinds of row:

    1. REFILLS — the refill(s) that actually fit that pen, matched on the pen's WRITING
                 MODE (ballpoint / rollerball / fountain / multifunction) and, where the
                 maison splits them, its FAMILY (modern lines vs the legacy Classique
                 family). Unlike the lighter card's butane row, refills are offered
                 immediately: there is no free-refill BxGy for pens, so there is no
                 "wait until the free one lands" condition to respect.
    2. PEN CASES — S.T. Dupont pen cases. These are NOT line-specific: the catalogue sells
                 them by capacity (X1 / X2 / X3 / X10) and colour, and no case's own copy
                 names a pen line. So every pen is offered the same ordered list, single-pen
                 cases first. Anything already in the cart, draft, or sold out drops off
                 BEFORE the cap is applied, so a sold-out case never eats a row slot.

  HOW THE PEN IS CLASSIFIED — mode first, family second
  Every pen in the catalogue names its mode in the title ("BALLPOINT PEN", "ROLLERBALL PEN",
  "FOUNTAIN PEN", "MULTIFUNCTION PEN", "MARKER PEN") — verified across all seven pen line
  collections (Classique, Initial, D-Initial, Line D, Line D Eternity, Defi Millennium,
  Liberte). As a safety net for any future product whose title omits it, the THIRD DIGIT of
  the SKU encodes the same thing and is used as a fallback:
      x_5_ -> ballpoint   (465099F, 045315N, 265002, 435220M, 275201, 445736)
      x_2_ -> rollerball  (462099F, 042079N, 262001, 432220XL, 272200, 442736)
      x_0_ -> fountain    (460099F, 040076N, 260203, 430220XL, 270200, 440736)
  This is the pen equivalent of the lighter card's collection-then-title chain: the strongest
  signal first, a mechanical fallback behind it, and no guessing beyond that.

  WHY FAMILY MATTERS (from the products' own descriptions, which are the fitment source of
  truth here exactly as the case PDF is for lighters):
    - 040854 / 040853 ballpoint — despite "DEFI" in the product title, the copy reads
      "Fits: Initial, D-Initial, Defi, Liberte, Line D and Line D Eternity ballpoint pens".
      It is the MODERN-lines ballpoint refill, not a Defi-only one.
    - 040851 ballpoint — "For the following pens: Olympio, Neo-classique, Classique 2,
      D.Link/Caprice, Fidelio, Ellipsis, Montparnasse, Gatsby and Mon Dupont by Karl
      Lagerfeld". That is the LEGACY family, which in this catalogue means Classique.
    - 040841 / 040840 rollerball — "The correct refill for every S.T. Dupont rollerball
      instrument", so it is offered on every rollerball regardless of family.
    - 040110 / 040112 cartridges — modern lines; bottles need the 408812 converter, which is
      why the converter is offered alongside them.
    - 040831 / 040830 soft tip — its copy lists BOTH families, so it is offered on every
      ballpoint as an alternative tip.
    - 040999 — "Fits: Mini Pen Necklace (ref. 700006)" only.
    - 040843 — "For: Neo-Classique President" only.

  DELIBERATELY NOT MAPPED: the MARKER NECKLACE pens (700002/3/4). No refill in the catalogue
  states that it fits a marker, so they get refill rows only if a match is ever added. Cases
  still show. Guessing here would put the wrong consumable in a customer's cart.

  THE 15% ITSELF is the same Shopify discount code "DUPONT15" the lighter card uses (15% off
  the add-ons collection, no minimum). Sharing one code is deliberate: Shopify applies only
  ONE automatic product discount per order, and two BxGy/automatic discounts do not stack —
  a second code-based product discount would also risk colliding. One collection, one code,
  behaviour already proven in production.

  Coexistence with the lighter card: this file uses its own data-elg-penaddon /
  data-elg-penaddon-variant attributes and its own .cart-penaddon class so the two cards
  never overwrite or re-trigger each other. A cart holding both a lighter and a pen shows
  both cards, lighter first.

  Loaded from snippets/meta-tags.liquid (rendered in <head> on every page).
*/
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var IS_FR = /^fr/i.test(document.documentElement.lang || '') || /^\/fr(\/|$)/.test(ROOT);

  var T = {
    label: IS_FR ? 'Complétez votre stylo — 15 % de rabais' : 'Complete your pen — save 15%',
    add: IS_FR ? 'Ajouter' : 'Add',
    note: IS_FR
      ? 'Le rabais de 15 % est appliqué au panier lors de l’ajout.'
      : '15% off is applied to your cart when you add.'
  };

  /* Same code as the lighter card — see the header comment for why there is only one. */
  var ADDON_CODE = 'DUPONT15';

  /* How many rows of each kind survive to the card. Raise these to show more; they exist so
     the drawer stays usable, not because the mapping runs out. */
  var MAX_REFILL_ROWS = 4;
  var MAX_CASE_ROWS = 3;

  /* ---------- refill fitment ---------- */

  var R = {
    bpModernBlack: 's-t-dupont-ballpoint-pen-refills-defi-medium-black-box-of-10', /* 040854 */
    bpModernBlue: 's-t-dupont-ballpoint-pen-refills-defi-medium-blue-box-of-10',   /* 040853 */
    bpLegacyBlack: 'bpp-refills-medium-black-10-040851',                           /* 040851 */
    bpLegacyBlue: 'ballpoint-pen-refills-medium-blue-box-of-10',                   /* 040850 */
    softBlack: 'soft-tip-refills-med-black-10-040831',                             /* 040831 */
    softBlue: 'soft-tip-refills-med-blue-10-040830',                               /* 040830 */
    miniNecklace: 's-t-dupont-mini-pen-necklace-refills-black-box-of-10',          /* 040999 */
    rbBlack: 's-t-dupont-rollerball-pen-refills-medium-black-box-of-10',           /* 040841 */
    rbBlue: 's-t-dupont-rollerball-pen-refills-medium-blue-box-of-10',             /* 040840 */
    rbMini: 'mini-roller-ball-refills-black-040843',                               /* 040843 */
    inkBlack: 's-t-dupont-fountain-pen-ink-cartridges-black-60-cartridges',        /* 040110 */
    inkBlue: 's-t-dupont-fountain-pen-ink-cartridges-blue-60-cartridges',          /* 040112 */
    inkRed: 'refill-ink-cartridges-red-10x6-040362',                               /* 040362 */
    inkGreen: 'refill-ink-cartridges-green-10x6-040363',                           /* 040363 */
    inkTurq: 'refill-ink-cartridges-turquois-10x6-040364',                         /* 040364 */
    converter: 'refill-convertor-for-fount-pen-408812',                            /* 408812 */
    bottleBlack: 'fountain-pen-ink-bottle-black',                                  /* 040165 */
    bottleRoyal: 'refill-ink-bottle-royal-blue-x1-040166',                         /* 040166 */
    bottleRed: 'refill-ink-bottle-red-x1-040167',                                  /* 040167 */
    bottleGreen: 'refill-ink-bottle-green-x1-040168',                              /* 040168 */
    bottleTurq: 'refill-ink-bottle-turquoise-x1-040169',                           /* 040169 */
    bottleDark: 'refill-ink-bottle-dark-blue-x1-040170',                           /* 040170 */
    multiRefills: '5-refills-defi-multifunction-040208',                           /* 040208 */
    multiRubbers: 'refill-5-rubbers-defi-multifunction10-040207',                  /* 040207 */
    leads07x12: 'pen-refills-12-leads-0-7mm-10-040205',                            /* 040205 */
    leads07: 'refill-lead-cartridges-0-7-mm-10-040203',                            /* 040203 */
    leads05: 'refill-lead-cartridges-0-5-mm-10-040202'                             /* 040202 */
  };

  /* mode + family -> ordered refill handles, best match first. */
  function refillsFor(mode, family) {
    /* Family wins over mode here. "MINI PEN NECKLACE BLACK / CHROME" (700006) names no mode at
       all, and its SKU's third digit is 0, so the mode fallback would read it as a fountain pen
       and offer it nothing. 040999 is made for exactly that reference, and it is the only refill
       the necklace takes, so the family alone decides. */
    if (family === 'mini-necklace') return [R.miniNecklace];
    if (family === 'marker') return []; /* nothing in the catalogue states marker fitment */

    if (mode === 'ball') {
      if (family === 'legacy') return [R.bpLegacyBlack, R.bpLegacyBlue, R.softBlack, R.softBlue];
      return [R.bpModernBlack, R.bpModernBlue, R.softBlack, R.softBlue];
    }
    if (mode === 'roller') {
      if (family === 'neo-classique') return [R.rbMini, R.rbBlack, R.rbBlue];
      return [R.rbBlack, R.rbBlue];
    }
    if (mode === 'fountain') {
      return [
        R.inkBlack, R.inkBlue, R.converter,
        R.inkRed, R.inkGreen, R.inkTurq,
        R.bottleBlack, R.bottleRoyal, R.bottleDark,
        R.bottleRed, R.bottleGreen, R.bottleTurq
      ];
    }
    if (mode === 'multi') {
      return [R.multiRefills, R.multiRubbers, R.leads07, R.leads05, R.leads07x12];
    }
    return [];
  }

  /* ---------- pen cases (capacity-based, not line-specific) ---------- */

  var PEN_CASES = [
    'soft-pen-case-x1-black-007121',                    /* 007121 Soft X1 Black      $260 */
    'rigid-pen-case-x1-black-leather',                  /* 007127 Rigid X1 Black     $400 */
    'rigid-pen-case-x1-silvery-mesh-007159',            /* 007159 Rigid X1 Silvery   $440 */
    'rigid-pen-case-x1-golden-mesh-007160',             /* 007160 Rigid X1 Golden    $440 */
    'rigid-pen-case-x1-orange-007172',                  /* 007172 Rigid X1 Orange    $400 */
    'soft-pen-case-x1-blue-007124',                     /* 007124 Soft X1 Blue       $260 */
    'rigid-pen-case-x1-blue-007130',                    /* 007130 Rigid X1 Blue      $400 */
    'pen-case-flap-x1-black-007167',                    /* 007167 Flap X1 Black      $330 */
    'xl-pen-case-x1-black-007174',                      /* 007174 XL X1 Black        $360 */
    'pen-case-soft-pen-sleeve-classiq-x1-black-007155', /* 007155 Sleeve X1 Black    $235 */
    'rigid-pen-case-x1-lampone-007169',                 /* 007169 Rigid X1 Lampone   $400 */
    'pen-case-soft-pen-sleeve-x1-silvry-mesh-007157',   /* 007157 Sleeve X1 Silvery  $300 */
    'pen-case-soft-pen-sleeve-x1-golden-mesh-007158',   /* 007158 Sleeve X1 Golden   $300 */
    'simple-pen-case-e-blue-d-line-180017',             /* 180017 D-Line Simple Blue $320 */
    'pen-case-pen-slot-e-blue-d-line-180016',           /* 180016 D-Line Slot Blue   $260 */
    'rigid-pen-case-x2-black-leather',                  /* 007131 Rigid X2 Black     $440 */
    'rigid-pen-case-x2-blue-007132',                    /* 007132 Rigid X2 Blue      $440 */
    'rigid-pen-case-x2-silvery-mesh-007161',            /* 007161 Rigid X2 Silvery   $480 */
    'rigid-pen-case-x2-golden-mesh-007162',             /* 007162 Rigid X2 Golden    $480 */
    'st-dupont-007111',                                 /* 007111 Leather X3 Black   $570 */
    'pen-case-pencil-case-leather-black-007113',        /* 007113 Pencil case Black  $450 */
    'pen-case-x10-black-007112'                         /* 007112 X10 Black        $1,100 */
  ];

  /* ---------- helpers (same maths and escaping as the lighter card) ---------- */

  function money(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    return '$' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
  }

  /* Mirrors Shopify's own line-discount rounding: round the discount, then subtract. */
  function salePrice(cents) {
    return cents - Math.round((cents * 15) / 100);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function has(title, keywords) {
    for (var i = 0; i < keywords.length; i++) {
      if (title.indexOf(keywords[i]) !== -1) return true;
    }
    return false;
  }

  function uniq(list) {
    var seen = {}, out = [];
    list.forEach(function (v) {
      if (v && !seen[v]) { seen[v] = 1; out.push(v); }
    });
    return out;
  }

  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(ROOT + 'products/' + handle + '.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function firstAvailableVariant(p) {
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) return p.variants[i];
    }
    return null;
  }

  /* ---------- classify a pen ---------- */

  /* Title is the primary signal; the SKU's third digit is the fallback. */
  function modeOf(title, sku) {
    if (has(title, ['MULTIFUNCTION'])) return 'multi';
    if (has(title, ['MARKER'])) return 'marker';
    if (has(title, ['FOUNTAIN'])) return 'fountain';
    if (has(title, ['ROLLERBALL', 'ROLLER BALL'])) return 'roller';
    if (has(title, ['BALLPOINT', 'BALL POINT'])) return 'ball';

    var digits = String(sku || '').replace(/[^0-9]/g, '');
    if (digits.length >= 3) {
      var d = digits.charAt(2);
      if (d === '0') return 'fountain';
      if (d === '2') return 'roller';
      if (d === '5') return 'ball';
    }
    return '';
  }

  /* Order matters: the more specific name is tested before the one it contains
     (MINI PEN NECKLACE before INITIAL, D-INITIAL before INITIAL, LINE D ETERNITY before
     LINE D). Families that share a refill collapse to 'modern'. */
  function familyOf(title) {
    if (has(title, ['MARKER NECKLACE', 'MARKER PEN'])) return 'marker';
    /* Matched on the full name only. Several Line D Eternity pens ship WITH a necklace and end
       "... + NECKLACE" — a looser test would misread those as the Mini Pen Necklace and offer
       them the wrong refill. */
    if (has(title, ['MINI PEN NECKLACE'])) return 'mini-necklace';
    if (has(title, ['NEO-CLASSIQUE', 'NÉO-CLASSIQUE', 'NEO CLASSIQUE'])) return 'neo-classique';
    if (has(title, ['CLASSIQUE', 'CLASSIQ'])) return 'legacy';
    if (has(title, [
      'LINE D ETERNITY', 'D ETERNITY', 'LINE D', 'D-INITIAL', 'INITIAL',
      'DEFI', 'DÉFI', 'LIBERTE', 'LIBERTÉ'
    ])) return 'modern';
    /* Unnamed limited editions (the pen equivalent of "20,000 Leagues") still get the
       modern refill, which is the one every current line takes. */
    return 'modern';
  }

  /* ---------- decide what to offer ---------- */

  function plan(cart) {
    var inCart = {};
    (cart.items || []).forEach(function (item) { inCart[item.handle] = true; });

    var refills = [];
    var sawPen = false;

    (cart.items || []).forEach(function (item) {
      /* Gate on the exact type "Writing Instruments". Pen cases are typed "Pen Cases" and
         refills "Pen Accessories", so neither can be mistaken for a pen — the same lesson as
         the lighter card's plural 'LIGHTERS' gate, which stopped a LIGNE 2 LIGHTER CASE from
         auto-adding butane. */
      var vendor = (item.vendor || '').toUpperCase();
      var type = (item.product_type || '').toUpperCase();
      if (vendor.indexOf('DUPONT') === -1) return;
      if (type.indexOf('WRITING INSTRUMENT') === -1) return;

      sawPen = true;
      var title = (item.product_title || item.title || '').toUpperCase();
      var family = familyOf(title);
      var mode = modeOf(title, item.sku || '');
      /* Families whose refill is decided by the family alone don't need a mode; everything else
         does, and an unclassifiable pen contributes no refill row rather than a guessed one. */
      if (!mode && family !== 'mini-necklace' && family !== 'marker') return;
      refills = refills.concat(refillsFor(mode, family));
    });

    if (!sawPen) return null;

    return {
      refills: uniq(refills).filter(function (h) { return !inCart[h]; }),
      cases: PEN_CASES.filter(function (h) { return !inCart[h]; })
    };
  }

  /* ---------- build the card ---------- */

  function rowHTML(p) {
    var v = firstAvailableVariant(p);
    if (!v) return '';
    var full = v.price;
    var sale = salePrice(full);
    var img = p.featured_image
      ? p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=120'
      : '';

    return (
      '<div class="cart-fbt__group">' +
        '<div class="cart-fbt__row">' +
          (img
            ? '<img class="cart-fbt__image" src="' + esc(img) + '" alt="' + esc(p.title) +
              '" width="52" height="52" loading="lazy">'
            : '') +
          '<div class="cart-fbt__info">' +
            '<a class="cart-fbt__title" href="' + esc(ROOT + 'products/' + p.handle) + '">' +
              esc(p.title) +
            '</a>' +
            '<span class="cart-fbt__price">' +
              '<s style="opacity:.55;font-weight:400;">' + money(full) + '</s> ' +
              money(sale) +
              ' <span class="cart-addon__tag">-15%</span>' +
            '</span>' +
          '</div>' +
          '<button type="button" class="cart-fbt__add" data-elg-penaddon-variant="' + v.id + '">' +
            esc(T.add) +
          '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function signature(products) {
    return products
      .map(function (p) { var v = firstAvailableVariant(p); return v ? v.id : ''; })
      .join('-');
  }

  function cardHTML(products) {
    var rows = products.map(rowHTML).join('');
    if (!rows) return '';
    return (
      '<div class="cart-fbt cart-addon cart-penaddon" data-elg-penaddon="' +
          esc(signature(products)) + '">' +
        '<span class="cart-fbt__label">' + esc(T.label) + '</span>' +
        rows +
        '<span class="cart-addon__note">' + esc(T.note) + '</span>' +
      '</div>'
    );
  }

  /* ---------- placement ---------- */

  function hosts() {
    var list = [];
    var drawer = document.getElementById('CartDrawer-CartItems');
    if (drawer) list.push(drawer);
    var page = document.getElementById('main-cart-items');
    if (page) list.push(page);
    return list;
  }

  function inject(host, html, sig) {
    var existing = host.querySelector('[data-elg-penaddon]');
    if (existing) {
      /* Same offer already in place -> no DOM write, which is what stops the
         MutationObserver from looping. */
      if (html && existing.getAttribute('data-elg-penaddon') === sig) return false;
      existing.remove();
      if (!html) return true;
    }
    if (!html) return false;

    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    var card = wrapper.firstChild;

    /* Sit after the lighter add-on card when both are showing, else after the FBT block. */
    var lighterCard = host.querySelector('[data-elg-addon]');
    var fbt = host.querySelector('.cart-fbt:not(.cart-addon)');
    var itemsWrap = host.querySelector('.drawer__cart-items-wrapper');
    if (lighterCard) lighterCard.insertAdjacentElement('afterend', card);
    else if (fbt) fbt.insertAdjacentElement('afterend', card);
    else if (itemsWrap) itemsWrap.insertAdjacentElement('afterend', card);
    else host.appendChild(card);

    if (itemsWrap) itemsWrap.classList.add('cart-items-capped');
    return true;
  }

  /* ---------- main loop ---------- */

  var busy = false;
  var timer = null;

  function apply(products) {
    var html = products.length ? cardHTML(products) : '';
    var sig = products.length ? signature(products) : '';
    var wrote = false;
    busy = true;
    hosts().forEach(function (h) { if (inject(h, html, sig)) wrote = true; });
    if (wrote) {
      setTimeout(function () { busy = false; }, 120);
    } else {
      busy = false;
    }
  }

  function usableOnly(products) {
    return products.filter(function (p) { return p && firstAvailableVariant(p); });
  }

  function run() {
    if (!hosts().length) return;
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var p = plan(cart);
        if (!p) { apply([]); return; }

        return Promise.all([
          Promise.all(p.refills.map(getProduct)),
          Promise.all(p.cases.map(getProduct))
        ]).then(function (res) {
          /* Cap only what survives the availability check, so a draft or sold-out product
             never consumes a row slot. */
          var refills = usableOnly(res[0]).slice(0, MAX_REFILL_ROWS);
          var cases = usableOnly(res[1]).slice(0, MAX_CASE_ROWS);
          apply(refills.concat(cases));
        });
      })
      .catch(function () { /* never break the cart */ });
  }

  function schedule() {
    if (busy) return;
    clearTimeout(timer);
    timer = setTimeout(run, 150);
  }

  /* Put DUPONT15 on the cart. Shopify accumulates discount codes, so this never evicts a
     code the customer entered themselves; re-applying an already-present code is a no-op. */
  var codeApplied = false;
  function applyCode() {
    if (codeApplied) return Promise.resolve();
    codeApplied = true;
    return fetch(ROOT + 'discount/' + ADDON_CODE + '?redirect=' + encodeURIComponent(ROOT + 'cart.js'), {
      redirect: 'follow'
    }).catch(function () { codeApplied = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-elg-penaddon-variant]');
    if (!btn) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-elg-penaddon-variant'), 10);
    if (!id) return;
    if (typeof window.elgFbtAdd === 'function') {
      if (!btn.disabled) {
        btn.disabled = true;
        var restore = btn.textContent;
        btn.textContent = '…';
        applyCode().then(function () {
          btn.disabled = false;
          btn.textContent = restore;
          window.elgFbtAdd(id, btn);
        });
      }
      return;
    }
    btn.disabled = true;
    applyCode().then(function () {
      return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : ROOT + 'cart') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      });
    }).then(function () { window.location.reload(); });
  }, true);

  /* The .cart-fbt__* rules live in snippets/cart-drawer.liquid. These .cart-addon rules are
     also injected by elg-dupont-addon.js under the same element id, so whichever script runs
     first wins and the second is a no-op — the pen card is not left unstyled if the lighter
     card is ever removed. */
  function injectStyles() {
    if (document.getElementById('elg-addon-css')) return;
    var s = document.createElement('style');
    s.id = 'elg-addon-css';
    s.textContent = [
      '.cart-addon{border-color:#B68A4E;}',
      '.cart-addon__tag{display:inline-block;margin-left:.4rem;padding:.1rem .6rem;border-radius:999px;',
      'background:#B68A4E;color:#15100B;font-size:1rem;font-weight:700;letter-spacing:.06em;vertical-align:middle;}',
      '.cart-addon__note{display:block;margin:.6rem 0 0;font-size:1.05rem;line-height:1.4;opacity:.7;}'
    ].join('');
    document.head.appendChild(s);
  }

  function start() {
    injectStyles();

    var watched = ['CartDrawer', 'main-cart-items', 'CartDrawer-CartItems'];
    var obs = new MutationObserver(function () { schedule(); });
    watched.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) obs.observe(el, { childList: true, subtree: true });
    });

    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('#cart-icon-bubble, .cart-drawer__continue')) {
        setTimeout(run, 300);
      }
    }, true);

    run();
    setTimeout(run, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
